import _slicedToArray from "/builds/JohnLewisPartnership/digital/services/online-checkout/checkout-ui/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import { jsx, jsxs, Fragment } from 'react/jsx-runtime';
import { useState, useEffect, useMemo } from 'react';
import { Elements } from '@stripe/react-stripe-js';
import { loadStripe } from '@stripe/stripe-js/pure';
import { stripeOptions } from './StripeProvider.config.js';
import { checkIsExpressEligibleCheckout, checkIsCardCheckout } from '../../utils/paymentMethod.js';
import StripePaymentForm from '../stripe-payment-form/StripePaymentForm.js';
import StripeExpressCheckoutElement from '../stripe-payment-form/stripe-express-checkout-element/StripeExpressCheckoutElement.js';
var StripeProvider = function StripeProvider(_ref) {
  var amount = _ref.amount,
    isStubbed = _ref.isStubbed,
    paymentMethodType = _ref.paymentMethodType,
    renderLoadingIndicator = _ref.renderLoadingIndicator,
    renderPaymentButton = _ref.renderPaymentButton,
    _ref$stripeConfig = _ref.stripeConfig,
    stripeConfig = _ref$stripeConfig === void 0 ? {} : _ref$stripeConfig;
  var _useState = useState(function () {
      return stripeOptions({
        amount: amount
      });
    }),
    _useState2 = _slicedToArray(_useState, 2),
    options = _useState2[0],
    setOptions = _useState2[1];
  var _useState3 = useState(null),
    _useState4 = _slicedToArray(_useState3, 2),
    stripe = _useState4[0],
    setStripe = _useState4[1];
  var _useState5 = useState(false),
    _useState6 = _slicedToArray(_useState5, 2),
    isReadyToRender = _useState6[0],
    setIsReadyToRender = _useState6[1];
  var afterFormContent = stripeConfig.afterFormContent,
    beforeButtonContent = stripeConfig.beforeButtonContent,
    billingDetails = stripeConfig.billingDetails,
    classNames = stripeConfig.classNames,
    metadata = stripeConfig.metadata,
    paymentHandlers = stripeConfig.paymentHandlers,
    publishableKey = stripeConfig.publishableKey,
    stripeAccount = stripeConfig.stripeAccount,
    _stripeConfig$loadStr = stripeConfig.loadStripe,
    loadStripe$1 = _stripeConfig$loadStr === void 0 ? loadStripe : _stripeConfig$loadStr;
  useEffect(function () {
    if (publishableKey && stripeAccount) {
      loadStripe$1(publishableKey, {
        betas: ['blocked_card_brands_beta_2'],
        stripeAccount: stripeAccount
      }).then(function (stripeInstance) {
        setStripe(stripeInstance);
      });
    } else {
      console.warn('StripeProvider: Missing Stripe Publishable Key or Account.');
    }
  }, [loadStripe$1, publishableKey, stripeAccount]);
  useEffect(function () {
    setOptions(stripeOptions({
      amount: amount
    }));
  }, [amount]);
  var _useMemo = useMemo(function () {
      return {
        isCardCheckout: checkIsCardCheckout(paymentMethodType),
        isExpressEligibleCheckout: checkIsExpressEligibleCheckout(paymentMethodType)
      };
    }, [paymentMethodType]),
    isCardCheckout = _useMemo.isCardCheckout,
    isExpressEligibleCheckout = _useMemo.isExpressEligibleCheckout;
  var defaultLoadingIndicator = jsx("p", {
    children: "Loading..."
  });
  var loadingIndicator = renderLoadingIndicator !== null && renderLoadingIndicator !== void 0 ? renderLoadingIndicator : defaultLoadingIndicator;
  if (!stripe && !isStubbed) return loadingIndicator;
  return jsxs(Fragment, {
    children: [isCardCheckout && !isReadyToRender && loadingIndicator, jsx(Elements, {
      options: options,
      stripe: stripe,
      children: isExpressEligibleCheckout ? jsx(StripeExpressCheckoutElement, {
        amount: amount,
        isStubbed: isStubbed,
        paymentHandlers: paymentHandlers,
        paymentMethodType: paymentMethodType
      }) : jsx(StripePaymentForm, {
        amount: amount,
        afterFormContent: afterFormContent,
        beforeButtonContent: beforeButtonContent,
        billingDetails: billingDetails,
        classNames: classNames,
        isStubbed: isStubbed,
        loadingIndicator: loadingIndicator,
        metadata: metadata,
        onReadyToRenderHandler: setIsReadyToRender,
        paymentMethodType: paymentMethodType,
        paymentHandlers: paymentHandlers,
        renderPaymentButton: renderPaymentButton
      })
    })]
  });
};
export { StripeProvider as default };